export const DATAPAGE = "DATAPAGE"
export const PARKLIST = "PARKLIST"
export const WECHATUSERQUERY = "WECHATUSERQUERY"
export const WECHATUSERADD = "WECHATUSERADD"
export const WECHATUSERUPDATE = "WECHATUSERUPDATE"
export const WECHATUSERDELET = "WECHATUSERDELET"
export const DISCERNRECORD = "DISCERNRECORD"



// WEBPACK FOOTER //
// ./src/store/app/park/types.js